import React, { useState, useEffect, useMemo, useRef } from 'react';
import { getCases } from '../services/casesService';
import { API_BASE_URL } from '../config/apiConfig';
import './Gallery.css';

const Gallery = () => {
  const [cases, setCases] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const startX = useRef(0);
  const deltaX = useRef(0);

  useEffect(() => {
    loadCases();
  }, []);

  const loadCases = async () => {
    try {
      const data = await getCases();
      setCases(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error cargando casos', err);
      setCases([]);
    }
  };

  const galleryItems = useMemo(() => {
    const urlBase = API_BASE_URL.replace('/api', '');

    return cases
      .map((caseItem) => {
        const parentMedia = (caseItem.media || [])
          .filter(m => m.active)
          .map(m => ({
            id: `parent-${m.id}`,
            type: m.type,
            src: `${urlBase}/storage/${m.path}`,
            title: caseItem.client_name,
            description: caseItem.description,
          }));

        const childrenMedia = (caseItem.children || []).flatMap(child =>
          (child.media || [])
            .filter(m => m.active)
            .map(m => ({
              id: `child-${child.id}-${m.id}`,
              type: m.type,
              src: `${urlBase}/storage/${m.path}`,
              title: child.client_name,
              description: child.description,
            }))
        );

        const mediaList = [...parentMedia, ...childrenMedia];
        if (!mediaList.length) return null;

        return {
          id: caseItem.id,
          title: caseItem.client_name,
          description: caseItem.description,
          mediaList,
        };
      })
      .filter(Boolean);
  }, [cases]);

  /* ===== SWIPE ===== */
  const handleStart = (e) => {
    setIsDragging(true);
    startX.current = e.touches ? e.touches[0].clientX : e.clientX;
  };

  const handleMove = (e) => {
    if (!isDragging) return;
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    deltaX.current = x - startX.current;
  };

  const handleEnd = () => {
    if (!isDragging || !selectedItem) return;

    const threshold = 70;
    const total = selectedItem.mediaList.length;

    if (deltaX.current < -threshold) {
      setCurrentIndex(i => Math.min(i + 1, total - 1));
    } else if (deltaX.current > threshold) {
      setCurrentIndex(i => Math.max(i - 1, 0));
    }

    deltaX.current = 0;
    setIsDragging(false);
  };

  return (
    <section id="galeria" className="gallery">
      <div className="gallery-grid">
        {galleryItems.map(item => (
          <div
            key={item.id}
            className="gallery-item"
            onClick={() => {
              setSelectedItem(item);
              setCurrentIndex(0);
            }}
          >
            <label className="gallery-label">
              {item.title} -
            </label>
            <label className="gallery-label-description">
              {item.description}
            </label>

            <div className="gallery-image">
              {item.mediaList[0].type === 'image' ? (
                <img
                  src={item.mediaList[0].src}
                  alt={item.title}
                />
              ) : (
                <div className="video-thumb">
                  <video
                    src={item.mediaList[0].src}
                    muted
                    playsInline
                  />
                  <div className="video-play-icon">▶</div>
                </div>
              )}

              <div className="gallery-overlay"></div>
            </div>

          </div>
        ))}
      </div>

      {/* ===== MODAL ===== */}
      {selectedItem && (
        <div className="gallery-modal">
          <div className="gallery-modal-content">

            <button
              className="gallery-modal-close"
              onClick={() => setSelectedItem(null)}
            >
              ×
            </button>

            <h2>{selectedItem.title}</h2>
            <p className="modal-description">
              {selectedItem.mediaList[currentIndex]?.description}
            </p>

            <div
              className="modal-swipe"
              onTouchStart={handleStart}
              onTouchMove={handleMove}
              onTouchEnd={handleEnd}
              onMouseDown={handleStart}
              onMouseMove={handleMove}
              onMouseUp={handleEnd}
              onMouseLeave={handleEnd}
            >
              {selectedItem.mediaList[currentIndex].type === 'image' ? (
                <img
                  src={selectedItem.mediaList[currentIndex].src}
                  draggable={false}
                  alt=""
                />
              ) : (
                <video
                  src={selectedItem.mediaList[currentIndex].src}
                  controls
                  muted
                  
                  playsInline
                />
              )}
            </div>

            {/* ===== DOTS ===== */}
            <div className="modal-dots">
              {selectedItem.mediaList.map((_, i) => (
                <span
                  key={i}
                  className={`dot ${i === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(i)}
                />
              ))}
            </div>

          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
